/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { SelectionHeader } from '../components/SelectionHeader';
import { SelectionCell } from '../components/SelectionCell';
const emptySelectionState = [[], () => { }];
export function useSelection({ selectionMode = 'multiple', selectionState, enabledRowIds, }) {
    const selectionEnabled = !!selectionState;
    const [selectedRowIds, setSelectedRowIds] = selectionState || emptySelectionState;
    // TODO: Memoise this
    const setSelected = (selected, rowId) => {
        if (rowId === undefined || rowId === null)
            return; // Can't use falsey, must allow number 0
        if (selected && selectionMode === 'single') {
            // Replace selectedRowIds with only the current rowId
            setSelectedRowIds([rowId]);
            return;
        }
        if (selected) {
            // Add rowId to selectedRowIds
            if (selectedRowIds.includes(rowId))
                return;
            const rowIds = [...selectedRowIds, rowId];
            setSelectedRowIds(rowIds);
        }
        else {
            // Remove rowIds from selectedRowIds
            const index = selectedRowIds.findIndex((id) => id === rowId);
            if (index < 0)
                return;
            const rowIds = [...selectedRowIds];
            rowIds.splice(index, 1);
            setSelectedRowIds(rowIds);
        }
    };
    // TODO: Memoise this
    const toggleAllSelected = () => {
        if (selectedRowIds.length === enabledRowIds.length) {
            setSelectedRowIds([]);
            return;
        }
        setSelectedRowIds(enabledRowIds);
    };
    // TODO: Memoise this
    const selectionColumn = {
        id: 'selection',
        title: 'Selection',
        width: '40px',
        align: 'center',
        pinned: 'left',
        renderHeader: (column, headerProps) => (React.createElement(SelectionHeader, Object.assign({}, headerProps, { selected: selectedRowIds.length === enabledRowIds.length, indeterminate: selectedRowIds.length > 0 && selectedRowIds.length < enabledRowIds.length, onChange: toggleAllSelected, selectionMode: selectionMode }))),
        renderCell: (row, cellProps, actions, rowState) => (React.createElement(SelectionCell, Object.assign({}, cellProps, { rowId: row.id, selected: rowState.selected, onChange: actions.setSelected, selectionMode: selectionMode, disabled: rowState.disabled }))),
    };
    return {
        selectionEnabled,
        selectedRowIds,
        selectionColumn,
        setSelected,
    };
}
//# sourceMappingURL=useSelection.js.map